import WidgetContextProvider from "../context/widget-context-provider";
import LicenseContextProvider from "../context/license-context-provider";
import NavApp from "./widget/nav-app";
import { Toaster } from "../components/ui/sonner";
import { AnimationProvider } from "@/context/animation-provider";
import ScanContextProvider from "@/context/scan-context-provider";

const NavWidgetApp = () => {
	return (
		<LicenseContextProvider>
			<WidgetContextProvider>
				<ScanContextProvider>
					<AnimationProvider>
						<NavApp />
					</AnimationProvider>
				</ScanContextProvider>
			</WidgetContextProvider>
		</LicenseContextProvider>
	);
};

export default NavWidgetApp;